export const ATTENTIVE_OVERLAY_ID = 'attentive_overlay'
export const ATTENTIVE_POPUP_VIEW_EVENT = 'Impression'
export const ATTENTIVE_EMAIL_SUBMIT_EVENT_KEY = 'submitEmail'
